import {SortableHandle} from "react-sortable-hoc";

export default SortableHandle(({children}) => {
    return children;
});